module.exports = __webpack_public_path__ + "img/msg.28ddbe9c.png";